(() => {
  if (window.hoMobileNavigationBound) return;
  window.hoMobileNavigationBound = true;
  // Native details/summary supports touch, Enter and Space without a script.
  // Close peers before the native default action opens this disclosure.
  // A delayed toggle listener can otherwise let an older event close a newly
  // opened sibling when someone moves quickly with the keyboard.
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.mobile-navigation summary');
    if (!summary) return;
    const opened = summary.parentElement;
    if (!(opened instanceof HTMLDetailsElement) || opened.open) return;
    const list = opened.parentElement.parentElement;
    if (!list.matches('ul')) return;
    for (const sibling of list.children) {
      const detail = sibling.querySelector(':scope > details');
      if (detail && detail !== opened) detail.open = false;
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !event.target.closest('.mobile-navigation')) return;
    const detail = event.target.closest('details[open]');
    if (!detail) return;
    event.preventDefault();
    event.stopPropagation();
    detail.open = false;
    detail.querySelector(':scope > summary').focus();
  }, true);
})();
